import { useCallback, useRef } from 'react'
import { useEvent, useIsomorphicLayoutEffect } from 'react-use'
import { Inter } from 'next/font/google'
import localFont from 'next/font/local'

export const calendas = localFont({
  src: [
    {
      path: './fonts/CalendasPlusItalic.woff2',
      weight: '400',
      style: 'italic'
    }
  ]
})

export const inter = Inter({
  weight: ['300', '400', '700', '800'],
  subsets: ['latin'],
  display: 'swap'
})

export type ThemeProps = Partial<{
  theme: 'dark' | 'light'
}>

const Theme = ({}: ThemeProps) => {
  const lastViewportWidth = useRef(0)

  const resize = useCallback(() => {
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (lastViewportWidth.current === viewportWidth) return
    lastViewportWidth.current = viewportWidth

    const vh = (viewportHeight * 0.01).toFixed(2)
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }, [])

  useIsomorphicLayoutEffect(() => resize(), [resize])

  useEvent('resize', resize)

  return (
    <style jsx global>{`
      :root {
        --font-family-serif: ${calendas.style.fontFamily};
        --font-family-base: ${inter.style.fontFamily};
        --header-height: 7.8rem;

        --font-size: 10px;
      }

      @media (min-width: 768px) {
        :root {
          --header-height: 7.8rem;
        }
      }
    `}</style>
  )
}

export default Theme
